import { cx } from '@linaria/core';
import { Video23Player } from '@pm2/media-component';
import { usePm2Modal } from '@pm2/ui-lightbox';
import { units } from '@ui/css';
import { PlayIcon, Button, PM2VideoIcon } from '@ui/kit';
import { usePageContext } from '../../context.js';
import { media } from './shared.style.js';
import { printThumbnail, printPlayIcon, printWrapper, tokens, player } from './video.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function VideoMedia(props) {
  const modal = usePm2Modal();
  const pageContext = usePageContext();
  if (pageContext === "print") {
    return /*#__PURE__*/jsxs("div", {
      className: cx(media, printWrapper),
      children: [/*#__PURE__*/jsx("img", {
        className: printThumbnail,
        src: props.node.twentyThreeVideo.thumbnail,
        alt: ""
      }), /*#__PURE__*/jsx("div", {
        className: printPlayIcon,
        children: /*#__PURE__*/jsx(PlayIcon, {})
      })]
    });
  }
  if (props.node.showInLightbox) {
    const onClick = () => {
      modal.fromContent(/*#__PURE__*/jsx(VideoComponent, {
        ...props
      }), {
        speechFile: undefined
      });
    };
    return /*#__PURE__*/jsx(Button, {
      theme: "primary",
      icon: /*#__PURE__*/jsx(PM2VideoIcon, {
        height: 16
      }),
      onClick: onClick,
      children: "Vis video i lightbox"
    });
  } else {
    return /*#__PURE__*/jsx(VideoComponent, {
      ...props
    });
  }
}
function VideoComponent(props) {
  return /*#__PURE__*/jsx("div", {
    className: cx(media, player),
    style: tokens.__override({
      aspect: `${props.node.twentyThreeVideo.width} / ${props.node.twentyThreeVideo.height}`,
      originalHeight: units.px(props.node.twentyThreeVideo.height ?? 10000),
      originalWidth: units.px(props.node.twentyThreeVideo.width ?? 10000)
    }),
    children: /*#__PURE__*/jsx(Video23Player, {
      photoId: props.node.twentyThreeVideo.id,
      token: props.node.twentyThreeVideo.token,
      aspectRatio: props.node.twentyThreeVideo.aspectRatio ?? undefined,
      title: props.node.title ?? undefined,
      caption: undefined,
      showSubtitlesByDefault: false
    })
  });
}

export { VideoMedia };
//# sourceMappingURL=video.js.map
